export default "__VITE_ASSET__Cj39kN8v__"